export default "__VITE_ASSET__CYGhV3uX__"